import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  readonly popoverSelector         : string = "a[rel='popover']"
  readonly diffExplanationSelector : string = "a#diff_explanation"
  readonly tabToggleSelector       : string = "a[data-toggle='tab']"
  readonly datepickerSelector      : string = "input.datepicker"
  readonly selectpickerSelector    : string = ".selectpicker"

  connect(): void {
    this.restoreTabs()
    this.initPopovers()
    this.initTabHistorification();
    this.initDatePicker();
  }

  disconnect(): void {
    $(this.popoverSelector).popover("dispose")
    $(this.diffExplanationSelector).popover("dispose")
    $(this.tabToggleSelector).off("shown.bs.tab")
    $(this.datepickerSelector).datepicker("destroy")
  }

  initPopovers() {
    $(this.popoverSelector).popover();

    // Diff explanation popover
    $(this.diffExplanationSelector).popover({
      trigger:   "hover",
      html:      true,
      placement: "bottom",
      content: function() {
        var selector = $(this).data("content-css");
        return $(selector).html();
      },
    });
  }

  // If landing on a page with a #! anchor, set the tab as active
  restoreTabs() {
    if (location.hash.slice(0, 2) == "#!") {
      $(`a[href="#${location.hash.slice(2)}"]`).tab("show");
    }
  }

  initTabHistorification() {
    // When showing a tab, if it starts with a hash, change its history to be #!
    $(this.tabToggleSelector).on("shown.bs.tab", function(event) {
      const href = $(event.target).attr("href") || "";

      if (href.slice(0, 1) == "#") {
        location.replace("#!" + href.slice(1));
      }
    });
  }

  initDatePicker() {
    $(this.datepickerSelector).datepicker({
      format:         "yyyy-mm-dd",
      autoclose:      true,
      clearBtn:       true,
      todayBtn:       "linked",
      todayHighlight: true,
    });
  }
}
